<template>
  <div class="out_wrap _common">
    <div class="back_wrap">
      <el-button @click="$router.go(-1)"><i class="el-icon-arrow-left" />返回</el-button>
      <span class="fs16 bold ml20">{{ $route.query.month }}</span>
    </div>
    <el-form :model="queryControl" label-width="52px">
      <div class="form-box">
        <el-form-item label="状态:" class="formItem">
          <el-select v-model="queryControl.invoice_status" placeholder="请选择" @change="queryDetail">
            <el-option label="全部" :value="''" />
            <el-option label="审批拒绝" :value="-1" />
            <el-option label="未发起审批" :value="0" />
            <el-option label="审批中" :value="1" />
            <el-option label="待开票" :value="2" />
            <el-option label="已开票" :value="3" />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <zf-table
      :columns="column"
      :data-source="tableData"
      :pagination="false"
    >
      <!-- 结算周期 -->
      <template
        slot="start_day"
        slot-scope="{ row }"
      >
        {{ row.start_day }} ~ {{ row.end_day }}
      </template>
      <!-- 对账金额 -->
      <template
        slot="rcon_price"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.rcon_price) }}
      </template>
      <!-- 已开票金额 -->
      <template
        slot="info"
        slot-scope="{ row }"
      >
        ￥{{ $formatCurrency(row.invoice_status == 3 ? row.rcon_price : '0.00') }}
      </template>
      <!-- 开票日期 -->
      <template
        slot="invoice_time"
        slot-scope="{ row }"
      >
        {{ row.invoice_time ? row.invoice_time : '-' }}
      </template>
      <!-- 状态 -->
      <template
        slot="invoice_status"
        slot-scope="{ row }"
      >
        <span v-if="row.invoice_status == -1" class="no_bg plub_width inline" style="width:74px">审批拒绝</span>
        <span v-if="row.invoice_status == 0" class="no_bg plub_width inline" style="width:84px">未发起审批</span>
        <span v-if="row.invoice_status == 1" class="conduct_bg plub_width inline">审批中</span>
        <span v-if="row.invoice_status == 2" class="wait_bg plub_width inline">待开票</span>
        <span v-if="row.invoice_status == 3" class="ableuse_bg plub_width inline">已开票</span>
      </template>
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a v-if="row.invoice_status == 3 && powerReg('4482755367a3b7de3ffbffdc5d42bfc2')" class="active_color" @click="show(row)">查看发票信息</a>
        <a v-else> - </a>
      </template>
    </zf-table>
    <el-dialog title="查看发票信息" :visible.sync="visible" width="400px" center>
      <div class="billBox">
        <div class="billItem flex">
          <div class="label">开票金额: </div>
          <div class="con flex1">￥{{ $formatCurrency(billInfo.price) || '0.00' }}</div>
        </div>
        <div class="billItem flex">
          <div class="label">发票类型: </div>
          <div class="con">
            <span v-if="billInfo.invoice_type == 1">增值税专用发票</span>
            <span v-if="billInfo.invoice_type == 2">增值税普通发票</span>
            <span v-if="billInfo.invoice_type == 3">增值税电子专用发票</span>
          </div>
        </div>
        <div v-if="billInfo.type == 1" class="billItem flex">
          <div class="label">快递信息: </div>
          <div class="con">
            <span v-if="billInfo.logistics_company == '顺丰快递'">顺丰快递</span>
            <span v-if="billInfo.logistics_company == '圆通快递'">圆通快递</span>
            <span v-if="billInfo.logistics_company == '韵达快递'">韵达快递</span>
            <span v-if="billInfo.logistics_company == '申通快递'">申通快递</span>
            <span v-if="billInfo.logistics_company == '邮政快递'">邮政快递</span>
            <span v-if="billInfo.logistics_company == '中通快递'">中通快递</span>
            <span v-if="billInfo.logistics_number">- {{ billInfo.logistics_number }}</span>
          </div>
        </div>
        <div v-else class="billItem flex">
          <div class="label">发票: </div>
          <div class="con">
            {{ billInfo.file_name }}
            <a class="active_color ml10" @click="downloadFile(billInfo.file_code)">下载</a>
          </div>
        </div>
        <div class="billItem flex">
          <div class="label">备注: </div>
          <div class="con" style="line-height:19px;">{{ billInfo.remark }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import column from './columns/billDetail'
import ZfTable from '@/components/ZfTable/CoreTable'
import { invoiceDetail, invoiceInfo } from '@/api/invoice'
export default {
  components: {
    ZfTable
  },
  data() {
    return {
      column,
      queryControl: {
        invoice_status: ''
      },
      tableData: [],
      visible: false,
      billInfo: {},
      total: '',
      pageControl: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.queryDetail()
  },
  methods: {
    async queryDetail() {
      const list = await invoiceDetail({
        month: this.$route.query.month,
        invoice_status: this.queryControl.invoice_status
      })
      if (JSON.stringify(list) !== '{}') {
        this.tableData = list.data
      } else {
        this.tableData = []
      }
    },
    async show(row) {
      const data = await invoiceInfo({
        recon_id: row.recon_id
      })
      if (data.code === 200) {
        this.billInfo = data.data
        this.billInfo.price = row.rcon_price
        this.visible = true
      }
    },
    downloadFile(code) {
      window.open(this.ExportUrl + '/api/downloadFile?file_code=' + code)
    }
  }
}
</script>

<style lang="scss" scoped>
.uploadBill ::v-deep .el-form-item{
  margin-bottom: 18px;
}
.billBox{
  .billItem{
    margin-bottom: 10px;
    .label{
      font-weight: 600;
      width: 80px;
      flex-shrink: 0;
      text-align: right;
    }
    .con{
      padding-left: 10px;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
